export const COMMUNITY_CHANNEL = '00000000-5000-0000-0000-000000000000';
export const SYSTEM_LIBRARY_ID = '00000000-5100-0000-0000-000000000000';
export const COMMON_LIBRARY_ID = '00000000-5200-0000-0000-000000000000';
export const LANE_TEMPLATE_LIBRARY_ID = '00000000-5300-0000-0000-000000000000';
export const SYSTEM_USER_ID = '00000000-55d5-ef82-6de8-e0531944e433';
export const COLUMN_CONTAINER_BLOCK_UUID =
  '5304ee1c-3e1a-4c2c-a3e7-791a7b06720b';
export const ROW_CONTAINER_BLOCK_UUID_BASE_64 = '5Jgi7itG5AYiTK7HC4Ojbp';
